import React from 'react'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { Colors } from 'src/shared/colors'

export const ValueLocked: React.FC = () => (
  <MaterialIcon icon={MaterialIconRef.Locker} size={12} color={Colors.Text2} />
)
